import { useMemo } from "react";
import { Flame } from "lucide-react";

/**
 * Simple 8-week heatmap (56 days) built from a { "YYYY-MM-DD": count } map.
 * Streak comes from the API.
 */
export default function StreakCalendar({ heatmap = {}, streak = 0 }) {
  const days = useMemo(() => {
    const arr = [];
    const today = new Date();
    for (let i = 55; i >= 0; i--) {
      const d = new Date(today);
      d.setDate(today.getDate() - i);
      const iso = d.toISOString().slice(0, 10);
      arr.push({ iso, count: heatmap[iso] || 0, label: d.toDateString() });
    }
    return arr;
  }, [heatmap]);

  const level = (c) => {
    if (!c) return "bg-slate-100";
    if (c === 1) return "bg-teal-200";
    if (c === 2) return "bg-teal-400";
    if (c < 5) return "bg-teal-600";
    return "bg-teal-800";
  };

  return (
    <div className="p-5 rounded-2xl bg-white border border-slate-200" data-testid="streak-calendar">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-xs text-slate-500 uppercase tracking-widest">Streak</div>
          <div className="font-display text-2xl font-bold text-slate-900 flex items-center gap-2" data-testid="streak-count">
            <Flame size={20} className="text-amber-500" strokeWidth={2.4} /> {streak} day{streak === 1 ? "" : "s"}
          </div>
        </div>
        <div className="text-xs text-slate-500">Last 8 weeks</div>
      </div>
      <div className="grid grid-flow-col grid-rows-7 gap-1">
        {days.map((d) => (
          <div key={d.iso} title={`${d.label} · ${d.count} activity`}
            className={`w-3 h-3 rounded-sm ${level(d.count)}`} />
        ))}
      </div>
    </div>
  );
}
